import React, { Component, Fragment } from 'react';
import { PropTypes } from 'prop-types';

class ModifyArray extends Component {
  state = {};

  handleRemoval = (i, item) => {
    const {
 subArray, sendUpNewArray, name, margin, map 
} = this.props;
    const updatedArray = [...subArray];
    updatedArray.splice(i, 1);
    sendUpNewArray(name, updatedArray, item);
  };

  render() {
    const {
      name, title, subArray, arrayLength, textColor, map,
    } = this.props;
    const { length } = subArray;

    return (
      <Fragment>
        <div className={`${map ? 'w-1/2' : 'w-full'}`}>
          <label className={`flex flex-col font-americaMonoRegular text-xs uppercase ${map && 'mr-2'}`} htmlFor={name}>
            <span className={`text-${textColor}`}>{title}</span>
            {length ? (
              <div className={`bg-grey px-2 my-2 py-1 flex flex-wrap ${length < arrayLength ? 'rounded-full' : 'rounded-lg'} `}>
                {subArray.map((item, i) => (
                  <div key={item + i} className="font-americaMonoBold text-xxs pl-4 pr-6 py-1 my-1 rounded-full bg-white text-black uppercase mx-1 relative">
                    {item}
                    <div onClick={() => this.handleRemoval(i, item)} className="absolute p-1 bg-black rounded-sm text-white cursor-pointer" style={{ right: 0, top: 0 }}>
                      X
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <input name={name} type="text" value="" disabled className="mt-2 rounded-full border-1 p-2 outline-none bg-grey mb-1" />
            )}
          </label>
        </div>
      </Fragment>
    );
  }
}

ModifyArray.propTypes = {
  name: PropTypes.string.isRequired,
  sendUpNewArray: PropTypes.func,
  title: PropTypes.string,
  subArray: PropTypes.arrayOf(PropTypes.string),
  arrayLength: PropTypes.number,
  textColor: PropTypes.string,
  margin: PropTypes.bool,
  map: PropTypes.bool,
};

ModifyArray.defaultProps = {
  sendUpNewArray: null,
  title: '',
  subArray: [],
  arrayLength: 4,
  textColor: 'white',
  margin: false,
  map: false,
};

export default ModifyArray;
